import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const DataSecurityInfo: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        7. Segurança de Informações Pessoais
      </Typography>

      <Typography paragraph>
        Para mantermos suas informações pessoais seguras, usamos ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção da sua privacidade, levando em consideração a natureza dos dados pessoais coletados, o contexto e a finalidade do tratamento e os riscos que eventuais violações gerariam para os direitos e liberdades do titular dos dados.
      </Typography>

      <Typography paragraph>
        Entre as medidas que adotamos, destacamos as seguintes:
      </Typography>

      <List>
        <ListItem>
          <ListItemText primary="• Apenas pessoas autorizadas têm acesso a seus dados pessoais;" />
        </ListItem>
        <ListItem>
          <ListItemText primary="• O acesso aos seus dados pessoais é feito somente após o compromisso de confidencialidade;" />
        </ListItem>
        <ListItem>
          <ListItemText primary="• Seus dados pessoais são armazenados em ambiente seguro e idôneo." />
        </ListItem>
      </List>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE se compromete a adotar as melhores práticas a fim de evitar incidentes de segurança. Contudo, é necessário destacar que nenhum sistema corporativo, aplicativo (app) ou página virtual são inteiramente seguros. É possível que, apesar de todos os nossos protocolos de segurança, problemas causados exclusivamente por terceiros ocorram, como ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do próprio usuário/cliente.
      </Typography>

      <Typography paragraph>
        Em caso de incidentes de segurança que possam gerar riscos ou danos relevantes a quaisquer usuários, comunicaremos ao(s) afetado(s) e à Autoridade Nacional de Proteção de Dados sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.
      </Typography>
    </div>
  );
};

export default DataSecurityInfo;
